<div fxLayout="row wrap">
  <div fxFlex.gt-sm="100" fxFlex.lt-sm="100">
    <p
      [innerHtml]="formDesc1"
      style="text-align: center; margin-top: 16px; font-weight: bold"
    ></p>
    <br />
    <form [formGroup]="form" fxLayout="row wrap" (ngSubmit)="submit(form)">
      <h3 fxFlex="100">Basic Details</h3>
      <br />
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" />
        <mat-error>First Name is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" />
        <mat-error>Last Name is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Email Address</mat-label>
        <input matInput formControlName="emailAddress" type="email" />
        <mat-error>Email Address is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Mobile Number</mat-label>
        <input matInput formControlName="mobileNumber" type="tel" />
        <mat-error>Mobile Number is required</mat-error>
      </mat-form-field>
      <div fxFlex="100"><br /></div>
      <h3 fxFlex="100">Business Details</h3>
      <br />
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Registered Name</mat-label>
        <input matInput formControlName="registeredName" />
        <mat-error>Registered Name is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Registration Number</mat-label>
        <input matInput formControlName="registrationNumber" />
        <mat-error>Registered Number is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Entity Type</mat-label>
        <mat-select formControlName="entityType">
          <mat-option [value]="item.value" *ngFor="let item of entityTypes">{{
            item.label
          }}</mat-option>
        </mat-select>
        <mat-error>An Entity Type is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Store Web Address</mat-label>
        <input matInput formControlName="storeWebAddress" />
        <mat-error>Store Web Address is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>eCommerce Platform</mat-label>
        <mat-select formControlName="eCommercePlatform">
          <mat-option
            [value]="item.value"
            *ngFor="let item of storePlatforms"
            >{{ item.label }}</mat-option
          >
        </mat-select>
        <mat-error>An eCommerce Platform is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Number of Physical Stores</mat-label>
        <input matInput formControlName="noPhysicalStores" type="number" />
        <mat-error>Number of Physical Stores is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Average Basket Size</mat-label>
        <input matInput formControlName="avgBasketSize" type="number" />
        <span matSuffix>ZAR</span>
        <mat-error>Average Basket Size is required</mat-error>
      </mat-form-field>
      <mat-form-field
        [appearance]="inputStyle"
        fxFlex.gt-sm="50"
        fxFlex.lt-sm="100"
      >
        <mat-label>Anticipated Credit Sales</mat-label>
        <input matInput formControlName="antCreditSales" type="number" />
        <span matSuffix>ZAR</span>
        <mat-error>Anticipated Credit Sales is required</mat-error>
      </mat-form-field>
      <mat-checkbox fxFlex="100" #termsConditions
        >I accept the
        <a
          href="https://drive.fevertreefinance.co.za/file/fetch/zeropay-partner-terms-conditions"
          target="_blank"
          >Merchant Terms & Conditions</a
        ></mat-checkbox
      >
      <div fxFlex="100">
        <ngx-recaptcha2
          #captchaElem
          siteKey="6LfKjAshAAAAAIrPttBP60KfFuepBPgOwuk6-kYJ"
          hl="en"
          type="image"
          formControlName="recaptcha"
          (expire)="form.controls['recaptcha'].setValue(null)"
        >
        </ngx-recaptcha2>
      </div>
      <div class="submission" fxFlex="100">
        <button
          [disabled]="!form.valid"
          [style.color]="!form.valid ? 'grey' : buttonTextColor"
          [style.backgroundColor]="!form.valid ? '#eee' : buttonColor"
          class="partner-submit"
          mat-raised-button
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
